export default __webpack_public_path__ + "static/media/about-mobile.9d6997c8.png";